"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCreateTicket(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 5h1v4h-1zm-2-1h5v1h-5z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#007AFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4 4h1v6h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6.4v1H0v-1z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#007AFF",
    d: "M21.867 1C22.493 1 23 1.474 23 2.06v9.98c0 .774-.672 1.403-1.501 1.403-.33 0-.65-.102-.912-.289l-1.69-1.209a1.195 1.195 0 00-1.42.032L15.23 13.75a1.194 1.194 0 01-1.46.002l-2.262-1.777a1.195 1.195 0 00-1.419-.029l-1.683 1.208c-.655.47-1.593.355-2.096-.258a1.34 1.34 0 01-.309-.85V11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#007AFF",
    d: "M6 3v-.94C6 1.474 6.507 1 7.133 1H22"
  })));
}

var MemoSvgCreateTicket = /*#__PURE__*/React.memo(SvgCreateTicket);
var _default = MemoSvgCreateTicket;
exports["default"] = _default;